module.exports = __webpack_public_path__ + "img/restrict.ff5de3b.svg";